import { useState } from "react";
import { useSelector } from "react-redux";
import editIcon from "../../../../images/icons/edit.svg";
import CategoryService from "../../../../services/CategoryService";
import { Badge } from "react-bootstrap";
import { Translate } from "../../../Enums/Tranlate";
import ConfirmModal from "../../../common/ConfirmModal";

const CardItem = ({ item, setAddModal, index, setItem, setShouldUpdate }) => {
	const [status, setStatus] = useState(item.status);
	const [statusModal, setStatusModal] = useState(false);
	const Auth = useSelector((state) => state.auth?.auth);
	const isExist = (data) => Auth?.roles?.includes(data);
	const lang = useSelector((state) => state.auth?.lang);
	const categoryService = new CategoryService();

	const changeStatus = () => {
		categoryService
			.toggleStatus(item?.id, { status: !item?.status })
			.then((res) => {
				if (!!res?.status) {
					setStatus(!item?.status);
					setShouldUpdate((prev) => !prev);
					setStatusModal(false);
				}
			});
	};

	return (
		<tr key={index} className="text-center">
			<td>{item[`name_${lang}`] || "-"}</td>
			<td>
				<img
					src={item?.image}
					className="cursor-pointer"
					alt="view"
					width={50}
				/>
			</td>
			<td>
				<Badge
					className="text-capitalize cursor-pointer"
					onClick={() => {
						if (
							isExist("update_category_management") ||
							isExist("delete_category_management")
						)
							setStatusModal(true);
					}}
					variant={`${status ? "success" : "danger"} light`}>
					{Translate[lang][status ? "active" : "deactive"]}
				</Badge>
			</td>
			<td>
				<div className="d-flex" style={{ gap: "20px" }}>
					{isExist("update_category_management") && (
						<img
							src={editIcon}
							onClick={() => {
								setItem(item);
								setAddModal(true);
							}}
							className="cursor-pointer"
							alt="edit"
							width={24}
						/>
					)}
				</div>
			</td>
			{statusModal && (
				<ConfirmModal
					open={statusModal}
					title={item[`name_${lang}`]}
					body={
						lang === "en"
							? `are you sure about changing status for this Category?`
							: "هل أنت متأكد من تغيير الحالة لهذا الفئه؟"
					}
					button={Translate[lang].submit}
					submitButton={changeStatus}
					onCloseModal={() => setStatusModal(false)}
				/>
			)}
		</tr>
	);
};
export default CardItem;
